export default "__VITE_ASSET__DcXwSKVQ__"